<template>
  <v-snackbar
    :timeout="4000"
    :top="true"
    v-model="showSnackbar"
  >
    {{ snackbarText }}
    <v-btn flat @click.native="closeSnackbar">
      Close
    </v-btn>
  </v-snackbar>
</template>

<script>

export default {
  name: 'snackbar',
  computed: {
    showSnackbar: {
      get () { return this.$store.state.appState.showSnackbar },
      set (value) { this.$store.commit('setShowSnackbar', value) }
    },
    snackbarText: {
      get () { return this.$store.state.appState.snackbarText }
    }
  },
  methods: {
    closeSnackbar () {
      this.$store.commit('setShowSnackbar', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/parts/utils/Snackbar.vue